import { MENU_CONFIG } from './menuConfig';

/**
 * Step "Moduli" della registrazione: aree di interesse a chip → sezioni REALI
 * del menu laterale (id di MENU_CONFIG con children). La selezione scrive
 * localStorage['expanded-menus'] (stessa chiave letta da Layout.tsx): sezioni
 * scelte = espanse al primo accesso, le altre restano collassate.
 * Zero modifiche a DB/permessi.
 */
export interface OnboardingArea {
  key: string;
  label: string;
  sections: string[]; // id di sezioni MENU_CONFIG (con children)
}

export const EXPANDED_MENUS_STORAGE_KEY = 'expanded-menus';

export const ONBOARDING_AREAS: OnboardingArea[] = [
  { key: 'sales-clients',     label: 'Vendite e clienti',          sections: ['crm', 'sales'] },
  { key: 'whatsapp',          label: 'WhatsApp',                   sections: ['communication'] },
  { key: 'projects',          label: 'Progetti e task',            sections: ['activities'] },
  { key: 'newsletter',        label: 'Newsletter',                 sections: ['communication'] },
  { key: 'invoicing',         label: 'Fatturazione',               sections: ['invoicing'] },
  { key: 'marketing',         label: 'Marketing',                  sections: ['marketing'] },
  { key: 'warehouse',         label: 'Magazzino',                  sections: ['services-inventory'] },
  { key: 'calendar-bookings', label: 'Calendario e prenotazioni',  sections: ['activities', 'communication'] },
];

/** Unione delle sezioni delle aree selezionate, dedup, in ordine MENU_CONFIG. */
export function computeExpandedSections(selectedKeys: string[]): string[] {
  const selected = new Set(selectedKeys);
  const sections = new Set<string>();
  for (const area of ONBOARDING_AREAS) {
    if (selected.has(area.key)) area.sections.forEach(s => sections.add(s));
  }
  return MENU_CONFIG
    .filter(item => item.children && item.children.length > 0 && sections.has(item.id))
    .map(item => item.id);
}
